export default __webpack_public_path__ + "static/media/Gilroy-ExtraBold.cb761043.woff";